export default __webpack_public_path__ + "static/media/StaticPage5.9cbc7f2c.txt";